import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateCut',
    standalone: false
})

// https://github.com/ngx-translate/core/issues/223#issuecomment-333335132

export class TranslateCutPipe implements PipeTransform {
  transform(value: string, index: any): string {
    const cutIndex = Number(index);
    return value.split('|')[cutIndex];
  }
}
